import store from "@/store";

/**
 * v-hasPerm 按钮权限处理
 */
export const hasPerm = {
  inserted(el, binding) {
    // // 管理员角色
    const user = store.getters;
    // if (user.roleList.includes("1")) {
    //   return true;
    // }
    // 其他角色
    const { value } = binding;
    if (value) {
      // 按钮权限标识，支持字符串或数组
      const requiredPerms = Array.isArray(value) ? value : [value];
      const hasPerm = user.permissions && user.permissions.some((perm) => {
        return requiredPerms.includes(perm);
      });
      if (!hasPerm) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error("need perms! Like v-has-perm=\"['sys:user:add','sys:user:edit']\"");
    }
  },
};

/**
 * v-hasRole 角色权限处理
 */
export const hasRole = {
  inserted(el, binding) {
    const { value } = binding;
    if (value) {
      // 支持字符串或数组
      const requiredRoles = Array.isArray(value) ? value : [value];
      const user = store.getters;
      const hasRole = user.roles && user.roles.some((role) => {
        return requiredRoles.includes(role);
      });

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error("need roles! Like v-has-role=\"['admin','test']\"");
    }
  },
};

